import { ListOffer } from 'types/types';
import { translateListOffer } from 'modules/offers/utils/translateListOffer';

export const translateListOffers = (response: object[]): ListOffer[] =>
  response.map(translateListOffer);
